/**
 * «Это ваше устройство?» — сразу после входа (§16.6).
 *
 * Своей формы входа у Ассистента нет (§16.2): любой запрос без сессии
 * уходит на портал экосистемы, а не на страницу входа. Вопрос «чужое ли
 * устройство» поэтому задаётся не до входа, а сразу после — в самом
 * приложении, один раз за вкладку (флаг в sessionStorage: он живёт до
 * закрытия вкладки, что и нужно — на новой вкладке спросится снова, как
 * и предписано §16.6: вход на каждом устройстве отдельный).
 */

import { useState } from 'react'
import { SessionExpired, api } from '../api/client'

const ASKED_KEY = 'device-trust-asked'

export function wasDeviceTrustAsked(): boolean {
  try {
    return sessionStorage.getItem(ASKED_KEY) === '1'
  } catch {
    // Приватный режим браузера может блокировать sessionStorage — не
    // блокировать вход из-за этого, просто не запоминать ответ.
    return true
  }
}

function rememberAsked(): void {
  try {
    sessionStorage.setItem(ASKED_KEY, '1')
  } catch {
    // см. wasDeviceTrustAsked — не критично, если не сохранилось.
  }
}

export function DeviceInterstitial({ onDone }: { onDone: () => void }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function choose(shared: boolean) {
    if (!shared) {
      rememberAsked()
      onDone()
      return
    }
    setBusy(true)
    setError(null)
    try {
      await api.markSharedDevice()
      rememberAsked()
      onDone()
    } catch (err) {
      if (err instanceof SessionExpired) {
        window.location.href = err.portalUrl
        return
      }
      setError(err instanceof Error ? err.message : String(err))
      setBusy(false)
    }
  }

  return (
    <div className="card interstitial">
      <h2>Это ваше личное устройство?</h2>
      <p className="muted">
        На чужом или общем устройстве (например, у клиента) сессия завершится сама при
        закрытии вкладки — анкеты и расчёты на нём не останутся.
      </p>

      {error != null && <p className="error">{error}</p>}

      <div className="actions">
        <button className="primary" disabled={busy} onClick={() => choose(false)}>
          Моё личное устройство
        </button>
        <button disabled={busy} onClick={() => choose(true)}>
          {busy ? 'Секунду…' : 'Чужое / общее устройство'}
        </button>
      </div>
    </div>
  )
}
